"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handles asynchronous Simport API calls with automatic retrying when a calls fail.
 */
var AsyncTask = function () {

    /**
    * Default function invoked when a Simport call fails.
    */
    // onFailure = null;

    /**
    * Default function invoked when Simport call succeeds.
    */
    // onSuccess = null;

    /**
    * Default function invoked when Simport call retries. return false to escape retry loop
    * @param lastErr   error returned from last attempt.
    * @param numberOfRetries   number of times retried for this method.
    */
    // onRetry(lastErr, numberOfRetries){ }


    /**
    * Returns an object for making asynchronous Simport calls.
    *
    * @param defaults   defaults get merged to 'this' on construction.
    */


    /**
    * How long to wait between retries
    */


    /**
    * Maximum number of requests to allow simultaneously
    */
    function AsyncTask() {
        var _this = this;

        var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, AsyncTask);
        this.maximumRetries = 3;
        this.maximumParallel = 1;
        this.haltQueueUponfail = true;
        this.timeBetweenRetries = 2000;
        this.pending = 0;
        this.runqueue = [];
        this.queue = [];
        this.context = null;

        (0, _keys2.default)(defaults).forEach(function (k) {
            if (defaults[k] != null) _this[k] = defaults[k];
        });
    }

    /**
    * How many pending items in the queue
    */


    /**
    * clear Queue if any request fails max times
    */


    /**
    * Maximum number of times to retry a failed call before giving up and reporting a failure.
    */


    (0, _createClass3.default)(AsyncTask, [{
        key: "runQueue",
        value: function runQueue() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (this.queue.length === 0) return;

            if (!this.runqueue.length && !this.pending && typeof this.onRun === "function" && !opts.skipOnRun) this.onRun.call(this);
            for (var x = 0, len = this.queue.length; x < len; x++) {
                var item = this.queue.shift();
                this.runqueue.push(item);
                this.runItem(item);
            }
        }
    }, {
        key: "runItem",
        value: function runItem(callTask) {
            var _this2 = this,
                _arguments = arguments;

            if (callTask.cancelled) {
                this.checkQueueComplete();
                return console.log("callTask cancelled");
            }

            if (this.maximumParallel && this.pending >= this.maximumParallel) return setTimeout(function () {
                console.log("waiting 500 ms");_this2.runItem.apply(_this2, _arguments);
            }, 500);

            this.pending++;
            callTask(function (err, haltQueueUponfail) {
                if (callTask.cancelled) return;
                if (err && haltQueueUponfail) {
                    debugger;
                    _this2.clearQueue();
                } else {
                    if (_this2.pending) _this2.pending--;
                    var index;
                    for (var i = 0; i < _this2.runqueue.length; ++i) {
                        if (_this2.runqueue[i] === callTask) {
                            index = i;
                            break;
                        }
                    }
                    if (index == null) throw new Error("missing calltask! may be already splliced?");
                    _this2.runqueue.splice(index, 1);
                    callTask.completed = true;
                }
                _this2.checkQueueComplete(err);
            });
        }
    }, {
        key: "checkQueueComplete",
        value: function checkQueueComplete(err) {
            var _this3 = this;

            if (this.queueTimer) clearTimeout(this.queueTimer);
            this.queueTimer = setTimeout(function () {
                if (_this3.pending === 0 && _this3.runqueue.length === 0) {
                    if (typeof _this3.onDone === "function") _this3.onDone.call(_this3, err);
                }
                clearTimeout(_this3.queueTimer);
                _this3.queueTimer = null;
            }, 300);
        }
    }, {
        key: "clearQueue",
        value: function clearQueue() {
            this.queue.length = 0;
            this.pending = 0;
            this.runqueue.forEach(function (i) {
                i.cancelled = true;
            });
            this.runqueue.length = 0;
        }

        /**
         * Called before trying to retry a Simport call that has failed.
         *
         * @param {function} retry  Function to call to retry a Simport call.
         */

    }, {
        key: "retry",
        value: function retry(retryTarget, callTask, lastErr, numberOfRetries, done) {
            var continueOn = true;
            if (typeof retryTarget === "function") continueOn = retryTarget.call(this, lastErr, numberOfRetries);

            if (continueOn === false) return done();

            if (this.timeBetweenRetries) {
                setTimeout(function () {
                    return callTask(done);
                }, +this.timeBetweenRetries);
            } else {
                callTask(done);
            }
        }
    }, {
        key: "runTask",


        /**
         * Executes an asynchronous Simport 3 task (or task fulfilling simport-like interface: (opts, success, error) => ... )
         *
         * @param {function} task           A Simport 3 asynchronous function to run.
         * @param {object?} [params]  Parameters for the given Simport 3 task.
         * @param {function} [options]    all options: onSuccess {function}, onFailure {function}, onRetry {function}, maximumRetries {int}
         */
        value: function runTask(task, params) {
            var _this4 = this;

            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!task) {
                throw new Exception("Task is required");
            }

            var numberOfRetries = 0;
            var failureTarget = options.onFailure || this.onFailure;
            var successTarget = options.onSuccess || this.onSuccess;
            var retryTarget = options.onRetry || this.onRetry;
            var maximumRetries = typeof options.maximumRetries === "number" ? options.maximumRetries : this.maximumRetries;

            var _callTask = void 0;
            var promise = new _promise2.default(function (resolve, reject) {
                _callTask = function callTask(done) {
                    var calledTask = _this4.context ? task.call(_this4.context, params) : task(params);
                    calledTask.then(function (res, xhr) {
                        if (!res && xhr.getResponseHeader('x-simport-error')) throw new Error(xhr.getResponseHeader('x-simport-error'));
                        if (typeof successTarget === "function") {
                            try {
                                successTarget(res);
                            } catch (e) {
                                numberOfRetries = maximumRetries;
                                console.error(e);
                                throw new Error("code error: " + e.stack);
                            }
                        }
                        done();
                        resolve(res);
                    }).catch(function (err, xhr) {
                        numberOfRetries++;
                        if (numberOfRetries < maximumRetries) {
                            _this4.retry(retryTarget, _callTask, err, numberOfRetries, done);
                        } else {
                            if (typeof failureTarget === "function") failureTarget(err);
                            done(err, _this4.haltQueueUponfail);
                            reject(err);
                        }
                    });
                };

                _this4.queue.push(_callTask);
                setTimeout(function () {
                    return _this4.runQueue(options);
                }, 10);
            });
            promise.callTask = _callTask;
            return promise;
        }
    }]);
    return AsyncTask;
}();

exports.default = AsyncTask;
;


//////////////////
// WEBPACK FOOTER
// ./~/trc-async-task/dist/trc-async-task.js
// module id = ./node_modules/trc-async-task/dist/trc-async-task.js
// module chunks = 0